// extracted by mini-css-extract-plugin
export var compact = "Datum-module--compact--HKCZ8";
export var data = "Datum-module--data--GWNS4";
export var divider = "Datum-module--divider--EtbMZ";
export var reverse = "Datum-module--reverse--ryPwx";
export var root = "Datum-module--root--fw3+Y";
export var stack = "Datum-module--stack--XxNHd";
export var text = "Datum-module--text--nIuIG";